export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/FilterIcon.63f06fb0.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};